import { useLocation, useParams } from 'react-router-dom';
import JobsTable from '../../components/Tables/JobsTable';
import { RoutePaths } from '../../routes/RoutePaths';
import { SaveJob, JobEntity } from '../../components';
import { StyledJobPageWrap, StyledTableContainer } from './JobsPage.styles';
import JobsPageStatistics from '../../components/JobsPageStatistics';
import { useAppDispatch, useAppSelector } from '../../base';
import { useEffectOnce } from 'react-use';
import { jobsActions, jobsSelectors } from '../../actions';
import LoadingPage from '../LoadingPage';
import { useEffect } from 'react';
import ConfirmJobCloseOrCancelModal from '../../components/ConfirmJobCloseOrCancelModal';

const JobsPage = () => {
    const location = useLocation();
    const dispatch = useAppDispatch();

    useEffectOnce(() => {
        dispatch(jobsActions.fetchJobAttributeList());
        dispatch(jobsActions.fetchJobRequirementsOptions({}));
        dispatch(jobsActions.fetchJobBenefitsOptions());
    });

    const jobAttributeList = useAppSelector(jobsSelectors.getJobAttributeList);
    const jobBenefitsOptions = useAppSelector(
        jobsSelectors.getJobBenefitsOptions
    );
    const activeJob = useAppSelector(jobsSelectors.getActiveJob);
    const isConfirmJobCloseOrCancelModalOpen = useAppSelector(
        jobsSelectors.getIsConfirmJobCloseOrCancelModalOpen
    );
    const { id } = useParams();
    const path = location.pathname;
    const isSaveJobPath = path?.includes(RoutePaths.saveJob);
    const pathElements = path?.replace(/\/+$/, '').split('/');
    const isEntityPath = ![RoutePaths.jobs, RoutePaths.saveJob].includes(
        '/' + pathElements[pathElements.length - 1]
    );
    const showTable = !isSaveJobPath && !isEntityPath;
    const cloneId: string | null = new URLSearchParams(location.search).get(
        'clone'
    );

    useEffect(() => {
        if ((id && String(id) !== String(activeJob?.id)) || cloneId) {
            dispatch(
                jobsActions.fetchActiveJob({ jobId: id || cloneId || '' })
            );
        }
    }, [dispatch, id, cloneId]);

    useEffect(() => {
        return () => {
            // Only clear if we're not navigating to another job page
            const isStillInJobContext = window.location.pathname.includes(
                RoutePaths.jobs
            );
            if (!isStillInJobContext) {
                dispatch(jobsActions.setActiveJob({ job: null }));
                dispatch(
                    jobsActions.setActiveJobCandidates({ candidates: [] })
                );
            }
        };
    }, [dispatch]);

    const renderSaveJob = () =>
        jobAttributeList?.length &&
        jobBenefitsOptions.length &&
        (!id || String(activeJob?.id) === id) &&
        (!cloneId || String(activeJob?.id) === cloneId) ? (
            <SaveJob id={id} isClone={!!cloneId} />
        ) : (
            <LoadingPage />
        );

    const renderJobEntity = () =>
        String(activeJob?.id) === id ? <JobEntity /> : <LoadingPage />;

    return (
        <>
            {isEntityPath && renderJobEntity()}
            {isSaveJobPath && renderSaveJob()}
            <StyledJobPageWrap showTable={showTable}>
                <JobsPageStatistics />
                <StyledTableContainer>
                    <JobsTable />
                </StyledTableContainer>
            </StyledJobPageWrap>
            <ConfirmJobCloseOrCancelModal
                isModalOpen={isConfirmJobCloseOrCancelModalOpen}
            />
        </>
    );
};

export default JobsPage;
